import React from "react";
import { FormattedMessage } from "react-intl";
import { PageMessage } from "../../../page/PageMessage";
import { ShieldLogo } from "../../../graphic/ShieldLogo/ShieldLogo";
import { Text } from "../../../typography/Text";
import Row from "../../../grid/Row";
import Col from "../../../grid/Col";

const msgKey = "accountActivationMessage";

export const MissingSubscription = ({ accountName }) => {
    return (
        <Row>
            <Col span={24}>
                <PageMessage
                    title={<FormattedMessage id={`${msgKey}.missingSubscriptionTitle`} />}
                    figure={<ShieldLogo size={100} />}
                >
                    <Text block size="medium" color="base80">
                        <FormattedMessage
                            id={`${msgKey}.missingSubscriptionMessage`}
                            values={{ name: accountName, strong: (msg) => <strong>{msg}</strong> }}
                        />
                    </Text>
                </PageMessage>
            </Col>
        </Row>
    );
};
